/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ck as Ck,
  rec_Componente_kk_107_107 as Componente_kk_107_107,
  rec_Dk as Dk,
  rec_Ek as Ek,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Ok as Ok,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Tk as Tk,
  rec_api as api,
  rec_wk as wk,
} from "../../runtime/index.jsx";
export function AnaliticaUso() {
  let e = (0, ReactCompiler.c)(35),
    [t, n] = (0, React.useState)(Ok),
    [r, i] = (0, React.useState)(Dk),
    [a, o] = (0, React.useState)(``),
    s;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((s = []), (e[0] = s))
    : (s = e[0]);
  let [c, l] = (0, React.useState)(s),
    [u, f] = (0, React.useState)(null),
    [p, m] = (0, React.useState)(``),
    h,
    _;
  (e[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((h = () => {
        api(`/unidades?paraProyectos=true`)
          .then(l)
          .catch((e) => m(e.message));
      }),
      (_ = []),
      (e[1] = h),
      (e[2] = _))
    : ((h = e[1]), (_ = e[2])),
    (0, React.useEffect)(h, _));
  let v, y;
  (e[3] !== a || e[4] !== t || e[5] !== r
    ? ((v = () => {
        let e = !0;
        return (
          f(null),
          t &&
            r &&
            api(
              `/analitica/resumen?desde=${t}&hasta=${r}${a ? `&unidad=${a}` : ``}`,
            )
              .then((t) => {
                e && (f(t), m(``));
              })
              .catch((t) => {
                e && m(t.message);
              }),
          () => {
            e = !1;
          }
        );
      }),
      (y = [t, r, a]),
      (e[3] = a),
      (e[4] = t),
      (e[5] = r),
      (e[6] = v),
      (e[7] = y))
    : ((v = e[6]), (y = e[7])),
    (0, React.useEffect)(v, y));
  let b;
  e[8] === c
    ? (b = e[9])
    : ((b = (e) => c.find((t) => String(t.id) === e)?.nombre || e),
      (e[8] = c),
      (e[9] = b));
  let x = b,
    S,
    C;
  e[10] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = (
        <h2
          className={`text-lg font-medium text-(--text-h)`}
          children={`Analítica de uso`}
        />
      )),
      (C = (
        <p
          className={`text-sm text-(--text)`}
          children={`Actividad registrada desde la activación de la analítica. Los usuarios se identifican por su ID; no se registra el contenido de tareas ni búsquedas.`}
        />
      )),
      (e[10] = S),
      (e[11] = C))
    : ((S = e[10]), (C = e[11]));
  let w;
  e[12] === t
    ? (w = e[13])
    : ((w = (
        <label
          className={`text-sm text-(--text)`}
          children={[`Desde`, <SelectorFecha value={t} onChange={n} />]}
        />
      )),
      (e[12] = t),
      (e[13] = w));
  let T = t || void 0,
    E;
  e[14] !== r || e[15] !== T
    ? ((E = (
        <label
          className={`text-sm text-(--text)`}
          children={[`Hasta`, <SelectorFecha value={r} min={T} onChange={i} />]}
        />
      )),
      (e[14] = r),
      (e[15] = T),
      (e[16] = E))
    : (E = e[16]);
  let D;
  e[17] === c ? (D = e[18]) : ((D = c.map(Ek)), (e[17] = c), (e[18] = D));
  let O;
  e[19] !== a || e[20] !== D
    ? ((O = (
        <SelectorMultiple
          placeholder={`Todas las áreas`}
          value={a}
          onChange={o}
          opciones={D}
        />
      )),
      (e[19] = a),
      (e[20] = D),
      (e[21] = O))
    : (O = e[21]);
  let k;
  e[22] !== E || e[23] !== O || e[24] !== w
    ? ((k = (
        <div className={`grid gap-3 sm:grid-cols-3`} children={[w, E, O]} />
      )),
      (e[22] = E),
      (e[23] = O),
      (e[24] = w),
      (e[25] = k))
    : (k = e[25]);
  let A;
  e[26] === p
    ? (A = e[27])
    : ((A = <EstadoError mensaje={p} />), (e[26] = p), (e[27] = A));
  let j;
  e[28] !== u || e[29] !== x
    ? ((j = u && (
        <JSXRuntime.Fragment
          children={[
            <p
              className={`text-sm text-(--text-h)`}
              children={[
                `Proyectos con uso: `,
                <strong children={u.proyectosActivos} />,
                ` · Sin uso registrado en el período: `,
                <strong children={u.proyectosSinUso} />,
              ]}
            />,
            <div
              className={`grid gap-3 md:grid-cols-2`}
              children={[
                <Componente_kk_107_107
                  titulo={`Funciones utilizadas`}
                  filas={u.eventos}
                  nombre={Tk}
                />,
                <Componente_kk_107_107
                  titulo={`Vistas consultadas`}
                  filas={u.vistas}
                  nombre={wk}
                />,
                <Componente_kk_107_107
                  titulo={`Usuarios activos por día`}
                  filas={u.porDia}
                />,
                <Componente_kk_107_107
                  titulo={`Usuarios activos por área`}
                  filas={u.porArea}
                  nombre={x}
                />,
                <Componente_kk_107_107
                  titulo={`Actividad por usuario`}
                  filas={u.usuarios}
                  nombre={Ck}
                />,
              ]}
            />,
          ]}
        />
      )),
      (e[28] = u),
      (e[29] = x),
      (e[30] = j))
    : (j = e[30]);
  let M;
  return (
    e[31] !== k || e[32] !== A || e[33] !== j
      ? ((M = (
          <section
            className={`flex flex-col gap-4`}
            children={[S, C, k, A, j]}
          />
        )),
        (e[31] = k),
        (e[32] = A),
        (e[33] = j),
        (e[34] = M))
      : (M = e[34]),
    M
  );
}
